import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/defer';

import { IndicatorGoalsPatch } from 'ri-api-client/dist';

import { ApiService } from '../api.service';
import { months } from 'moment';

export interface Indicator {
  'month'?: number;
  'quantityVisits'?: number;
  'quantityInspections'?: number;
  'averageEnergyIncreased'?: number;
  'averageEnergyRecovered'?: number;
  'billed'?: number;
  'billedPercentage'?: number;
  'energyIncreased'?: number;
  'energyRecovered'?: number;
  'fraudPercent'?: number;
  'irregularityPercent'?: number;
  'nonFraudPercent'?: number;
  'notInspectedPercent'?: number;
  'hitRateInspection'?: number;
  'hitRateVisit'?: number;
  'productivityIncreasedInspection'?: number;
  'productivityIncreasedVisit'?: number;
  'productivityRecoveredInspection'?: number;
  'productivityRecoveredVisit'?: number;
  'productivityRecoveredBilled'?: number;
}

@Injectable()
export class IndicatorGoalsService {

  private options: any;

  constructor(
    private apiService: ApiService
  ) { }

  getYearIndicator(year: string): Observable<any[]> {
    return this.apiService.client.indicatorGoals.year(year).GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getYearMonthIndicator(startYear: string, startMonth: string, endYear: string, endMonth: string): Observable<any> {
    return this.apiService.client.indicatorGoals.startYear(startYear).startMonth(startMonth).endYear(endYear).endMonth(endMonth).GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }


  setYearIndicator(indicatorGoals: IndicatorGoalsPatch.IndicatorGoalsPatch, year?: string): Observable<any> {
    return this.apiService.client.indicatorGoals.year(year).PATCH(indicatorGoals, this.options);
  }

}





// WEBPACK FOOTER //
// ./src/app/core/api/indicator-goals.service.ts